import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { Sparkles, AppMarket } from '@wix/wix-ui-icons-common';
import { SelectionCard } from 'components/SelectionCard/SelectionCard';
import styles from '../SelectStoreTypeStep.scss';
import { useAppStore } from 'stores/state';
import { StoreType } from 'config/enums';
import { useOrchestratorNavigation } from '@wix/gg-common-lib/orchestrator';
import { BI_ACTION_NAME, BI_BUTTON_NAME, BI_STEP_NAME } from 'config/bi-events';
import { biEvents } from 'api/bi-events';
import { StepId } from 'config/flow';

export const SelectStoreTypeStepOptions: FC = () => {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();

  const storeType = useAppStore((state) => state.storeType);
  const setStoreType = useAppStore((state) => state.setStoreType);

  const handleSelectStoreType = (type: StoreType) => {
    setStoreType(type);
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.SelectStoreType],
      button_name: BI_BUTTON_NAME.OPTION_SELECTED,
      action: BI_ACTION_NAME.NEXT,
      value: type,
    });
    next();
  };

  return (
    <div className={styles.selectStoreTypeStepOptions}>
      <SelectionCard
        description={t('select-store-type-step.options.item.description.NEW_STORE')}
        title={t('select-store-type-step.options.item.title.NEW_STORE')}
        onClick={() => handleSelectStoreType(StoreType.NEW)}
        isSelected={storeType === StoreType.NEW}
        icon={<Sparkles />}
      />
      <SelectionCard
        description={t('select-store-type-step.options.item.description.EXISTING_STORE')}
        title={t('select-store-type-step.options.item.title.EXISTING_STORE')}
        onClick={() => handleSelectStoreType(StoreType.EXISTING)}
        isSelected={storeType === StoreType.EXISTING}
        icon={<AppMarket />}
      />
    </div>
  );
};
